export default {
  total: state => state.total,
  items: state => state.items,
  success: state => state.success
};